// 🚫 B361 (AI_156) — "ESTE ACHADO FOI NEGADO?" EM CAMPO DE LAUDO
// ─────────────────────────────────────────────────────────────
// Campos estruturados de imagem (shunts, trombose, ascite…) são preenchidos com
// texto livre curto, e o jeito de dizer "não tem" varia muito: "Não", "Sem
// shunts", "Ausente", "Não identificados", "Não caracterizada", "Ausência de…".
// Quem comparava com uma lista fixa ("não"/"nao"/"ausentes") lia "Sem shunts"
// como shunt PRESENTE — foi o que pôs "Shunts portossistêmicos: SIM" num
// paciente cujo ultrassom dizia "sem shunts" (achado ao vivo, AI_156).
//
// Decisão de desenho: na dúvida, NEGATIVO vence. Um achado afirmado de verdade
// traz descrição ("shunt esplenorrenal de 8 mm"), que não casa nenhum padrão
// daqui; já a frase negativa tem forma previsível. O erro perigoso é afirmar um
// achado que o laudo negou.
// ─────────────────────────────────────────────────────────────

const semAcento = (s: string) =>
  s.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase().trim();

// Negações no INÍCIO do campo ("Sem shunts", "Não identificados", "Ausente").
const INICIO_NEGATIVO =
  /^(nao|sem|ausente|ausentes|ausencia|negativo|negativa|nenhum|nenhuma|normal|-|0)\b/;

// Negações no MEIO ("Fígado sem shunts", "shunts não caracterizados").
const TRECHO_NEGATIVO =
  /\b(sem (shunt|variz|trombos|ascite|lesao|sinais|evidencia)|nao (identificad|caracterizad|evidenciad|visualizad|demonstrad|detectad|observad)|ausencia de)/;

/** `true` quando o campo NEGA o achado (ou está vazio). */
export function ehRespostaNegativa(valor: unknown): boolean {
  if (valor === undefined || valor === null) return true;
  if (typeof valor === "boolean") return valor === false;
  const t = semAcento(String(valor));
  if (t === "") return true;
  return INICIO_NEGATIVO.test(t) || TRECHO_NEGATIVO.test(t);
}

/** `true` só quando o campo AFIRMA o achado. */
export function ehRespostaPositiva(valor: unknown): boolean {
  if (typeof valor === "boolean") return valor === true;
  if (valor === undefined || valor === null) return false;
  if (String(valor).trim() === "") return false;
  return !ehRespostaNegativa(valor);
}
